// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"common_buttonPrimary__Eb+hO","buttonSecondary":"common_buttonSecondary__9cs8u","box":"common_box__Tw3DZ"};